module.exports = __webpack_public_path__ + "img/KEYS.fb0aca78.svg";